import React from "react";

const WorkRequest = ({ ...props }) => {
    return (
      <div>
        <p>
          Coming soon
        </p>
      </div>
    );
  };
  
  export default WorkRequest;